(() => {
	let slideshowSwipers = []; // Store all slideshow Swiper instances

	const initSliders = () => {
		const slideshows = document.querySelectorAll(".main-blog__featured-posts .swiper");
  		slideshows.forEach((slideshow) => {
  			
  			const slideshowSwiper = new Swiper(slideshow, {
                   slidesPerView: 1.5,
                    spaceBetween: 10,
                    autoplay: true,
                    breakpoints: { 
                        576: { 
                            slidesPerView: 2.5
                        },
                        768: {  
                            slidesPerView: 3.5
                        },
                        990: {  
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        1200: {  
                            slidesPerView: 4,
                            spaceBetween: 20,
                        },
                        1400: {  
                            slidesPerView: 4,
                            spaceBetween: 20,
                        }
                    },
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    // loop: true,
                    navigation: {
                        nextEl: '.main-blog__featured-posts .swiper-button-next',
                        prevEl: '.main-blog__featured-posts .swiper-button-prev',
                    },
                    observer:true,
                    observeParents:true,
    		});
  	})
    }
	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();
